import { alpha } from '@theme-ui/color'
import Svg from 'components/UI/SVG'
import { ColorModesScale, Flex, Text } from 'theme-ui'

export default function FeatureBox({
  title,
  subtitle,
  colour,
  icon,
}: {
  title: string
  subtitle: string
  colour: ColorModesScale[string]
  icon?: React.ElementType
}): JSX.Element {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        border: '0.2rem solid',
        borderRadius: '1.6rem',
        borderColor: alpha(colour, 0.25),
        backgroundColor: alpha(colour, 0.05),
        p: '2.4rem',
      }}
    >
      <Flex sx={{ alignItems: 'center', gap: '1.6rem' }}>
        {icon && (
          <Svg svg={icon} sx={{ width: '2.4rem', height: '2.4rem', path: { fill: colour } }} />
        )}
        <Text as="h3" sx={{ color: colour }} variant="h3BigBold">
          {title}
        </Text>
      </Flex>

      <Text sx={{ mt: '1.6rem' }} variant="paragraphBigRegular">
        {subtitle}
      </Text>
    </Flex>
  )
}
